/**
 * Trunnion AI - Agent List Page
 */

import { AgentListView } from '@/components/agents/AgentListView';

export default function AgentListPage() {
  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-white">Agents</h1>
        <p className="mt-1 text-sm text-trunnion-slate-400">
          Manage AI agents with tiered access, tool whitelists, and clearance levels.
        </p>
      </div>
      <AgentListView />
    </div>
  );
}
